import { DeleteOutlined } from "@ant-design/icons"
import { Button, Card, Flex, Form, Input, Tooltip, Typography } from "antd"
import React from "react"

import type { ProjectTypeFormData } from "./ProjectType.tsx"

interface ProjectTypeCardProps {
  deleteAllowed?: boolean
  onDeleteClick: () => void
}

export function ProjectTypeCard({
  deleteAllowed,
  onDeleteClick
}: ProjectTypeCardProps) {
  return (
    <Card classNames={{ body: "p-2" }}>
      {/*  <Form.Item<ProjectTypeFormData>*/}
      {/*    noStyle*/}
      {/*    name="is_active"*/}
      {/*    valuePropName="checked"*/}
      {/*  >*/}
      {/*    <Switch checkedChildren="Active" unCheckedChildren="Inactive" />*/}
      {/*  </Form.Item>*/}
      {/*</Flex>*/}
      <Flex
        className={"w-full px-[3px]"}
        justify={"space-between"}
        align={"start"}
      >
        <Flex gap={4} align={"center"} className={"pb-2"}>
          <Typography.Text type={"danger"} className={"text-xs"}>
            *
          </Typography.Text>
          Project Type Name
        </Flex>
        {deleteAllowed && (
          <Tooltip title={"Delete project type"}>
            <Button
              size={"small"}
              type={"text"}
              danger
              onClick={onDeleteClick}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        )}
      </Flex>

      <Form.Item<ProjectTypeFormData>
        name={["projectType", "name"]}
        rules={[{ required: true, message: "Please enter name" }]}
      >
        <Input placeholder="Enter name" />
      </Form.Item>

      <Form.Item<ProjectTypeFormData>
        label={"Project Type Description"}
        name={["projectType", "description"]}
        rules={[{ required: false, message: "Please enter description" }]}
      >
        <Input.TextArea placeholder="Enter description" />
      </Form.Item>
    </Card>
  )
}
